<h1 mat-dialog-title align="center" style="color: red;">แน่ใจว่าลบบิลนี้</h1>
<div mat-dialog-content>
    <h1>{{data.name}}</h1>
    <label>รหัส</label>
    <input id="password" type="text" [formControl]="passwordControl">
</div>
<div mat-dialog-actions align="center">
    <button mat-button mat-dialog-close="false">ไม่ลบ</button>
    <button mat-button mat-dialog-close="delete" [disabled]="passwordControl.value !== '8842'">ลบ</button>
</div>
